import React, { Component, lazy, Suspense } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { isLoaded, isEmpty } from 'react-redux-firebase'
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  useParams,
} from 'react-router-dom'
import { parseURL } from './utils/href'
import SchemaVersionErrorPage from './SchemaErrorPage'
import { LoadingPage } from 'mds-web-ui'

const Login = lazy(
  () => import(/* webpackChunkName: "login" */ './components/Login'),
)
const Logout = lazy(
  () => import(/* webpackChunkName: "logout" */ './components/Logout'),
)
const ActionsPage = lazy(
  () =>
    import(/* webpackChunkName: "actionspage" */ './components/ActionsPage'),
)

const RedirectLegacyUToA = () => {
  const { id } = useParams()
  return <Navigate to={`/a/${id}`} replace />
}

class ActionsHomeInner extends Component {
  static propTypes = {
    auth: PropTypes.object,
    location: PropTypes.object,
  }

  render() {
    const { auth, location } = this.props

    // handle initial loading of auth
    if (!isLoaded(auth)) {
      // TODO nicer loading animation
      return <LoadingPage />
    }

    // auth is empty (i.e. not logged in)
    if (isEmpty(auth)) {
      return (
        <Navigate
          to="/login"
          replace
          state={{ from: { pathname: location.pathname } }}
        />
      )
    }

    const { logbookVisible, preferencesVisible } = parseURL(location.pathname)

    return (
      <SchemaVersionErrorPage>
        <ActionsPage
          uid={auth.uid}
          displayName={auth.displayName}
          logbookVisible={logbookVisible}
          preferencesVisible={preferencesVisible}
        />
      </SchemaVersionErrorPage>
    )
  }
}

const ActionsHomeConnected = connect(({ firebase: { auth } }) => ({ auth }))(
  ActionsHomeInner,
)
ActionsHomeConnected.displayName = 'ActionsHome'

const ActionsHome = () => {
  const location = useLocation()
  return <ActionsHomeConnected location={location} />
}

export const Home = () => (
  <Suspense fallback={<LoadingPage />}>
    <Routes>
      <Route path="u/:id" element={<RedirectLegacyUToA />} />
      <Route path="l/*" element={<Navigate to="/" replace />} />
      <Route path="login" element={<Login />} />
      <Route path="logout" element={<Logout />} />
      <Route path="*" element={<ActionsHome />} />
    </Routes>
  </Suspense>
)
